import { useEffect } from 'react';
import { getSetting, setSetting } from '../services/persistence';
import { useEditorStore, type Workspace } from '../store/editorStore';

interface WorkspacePreferences {
  workspace: Workspace;
  leftPanel: 'media' | 'layers' | 'effects' | 'text' | 'templates';
  timelineZoom: number;
  leftPanelWidth: number;
  inspectorWidth: number;
  timelineHeight: number;
  snapping: boolean;
}

export function useWorkspacePreferences() {
  useEffect(() => {
    let timeout = 0;
    void getSetting<WorkspacePreferences>('workspacePreferences').then((preferences) => {
      if (preferences) useEditorStore.setState(preferences);
    });
    const unsubscribe = useEditorStore.subscribe((state, previous) => {
      const changed = state.workspace !== previous.workspace || state.leftPanel !== previous.leftPanel || state.timelineZoom !== previous.timelineZoom || state.leftPanelWidth !== previous.leftPanelWidth || state.inspectorWidth !== previous.inspectorWidth || state.timelineHeight !== previous.timelineHeight || state.snapping !== previous.snapping;
      if (!changed) return;
      clearTimeout(timeout);
      timeout = window.setTimeout(() => void setSetting('workspacePreferences', {
        workspace: state.workspace,
        leftPanel: state.leftPanel,
        timelineZoom: state.timelineZoom,
        leftPanelWidth: state.leftPanelWidth,
        inspectorWidth: state.inspectorWidth,
        timelineHeight: state.timelineHeight,
        snapping: state.snapping
      } satisfies WorkspacePreferences), 400);
    });
    return () => { clearTimeout(timeout); unsubscribe(); };
  }, []);
}
